import type { InjectionKey } from 'vue';
import { IAPILogger } from '@/Interfaces/IAPILogger';
import { RootLogger } from 'loglevel';

export const loggerKey = Symbol() as InjectionKey<RootLogger>;
export const apiLoggerKey = Symbol() as InjectionKey<IAPILogger>;
export const globalReloadKey = Symbol() as InjectionKey<() => void>;